import type { DiagramElement, Point } from "../domain/drill";

export type SelectionBox = { start: Point; current: Point };

export function normalizedSelectionBox(box: SelectionBox) {
  return {
    x: Math.min(box.start.x, box.current.x),
    y: Math.min(box.start.y, box.current.y),
    width: Math.abs(box.current.x - box.start.x),
    height: Math.abs(box.current.y - box.start.y),
  };
}

function bounds(element: DiagramElement) {
  if (element.type === "path") {
    const xs = element.points.map((point) => point.x);
    const ys = element.points.map((point) => point.y);
    return {
      x: Math.min(...xs),
      y: Math.min(...ys),
      width: Math.max(...xs) - Math.min(...xs),
      height: Math.max(...ys) - Math.min(...ys),
    };
  }
  if (element.type === "text")
    return {
      x: element.point.x - 5,
      y: element.point.y - element.fontSize,
      width: Math.max(55, element.value.length * element.fontSize * 0.62),
      height: element.fontSize * 1.35,
    };
  const radius = 30 * (element.size ?? 1);
  return {
    x: element.point.x - radius,
    y: element.point.y - radius,
    width: radius * 2,
    height: radius * 2,
  };
}

export function elementsInSelection(
  elements: DiagramElement[],
  selection: SelectionBox,
) {
  const area = normalizedSelectionBox(selection);
  return elements
    .filter((element) => {
      const item = bounds(element);
      return (
        item.x <= area.x + area.width &&
        item.x + item.width >= area.x &&
        item.y <= area.y + area.height &&
        item.y + item.height >= area.y
      );
    })
    .map((element) => element.id);
}
